export default {
  methods: {
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
  },
  computed: {
    /**
     * computed value to watch if game should be checkd
     * @method checkGame
     * @return {Boolean}  if true then performe check action
     */
    checkGame() {
      return this.$store.getters.checkGame;
    },
    /**
     * computed value to watch if game should be resetGame
     * @method resetGameSwitch
     * @return {Boolean}  if true then performe reset action
     */
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
    /**
     * local value for font sieze default 40px
     * @method gameFontSize
     * @return {Number}     font sieze in px
     */
    gameFontSize() {
      if (this.startGameConfig.gameFontSize) {
        return this.startGameConfig.gameFontSize + 'px';
      }
      return 'inherit';
    },
  },
  watch: {
    /**
     * watch on computed value checkGame
     */
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    /**
     * watch on computed value resetGameSwitch
     */
    resetGameSwitch(newStatus, oldStatus) {
      // // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
